import React, { useState, useContext, FunctionComponent } from 'react'
import { Toast, ToastContext, ToastItem } from './Toast'
import { ToastLifecycle } from './constants'
import { ToastOptions, InternalToastOptions, ToastProviderProps, SetToastFn } from './types'

export const ToastProvider: FunctionComponent<ToastProviderProps> = ({ children, ...otherProps }) => {
  const [toastList, setToastList] = useState<InternalToastOptions[]>([])
  const value = { toastList, setToastList }

  return (
    <ToastContext.Provider value={value}>
      <Toast />
      {children}
    </ToastContext.Provider>
  )
}

export const useToast = (): SetToastFn => {
  const { toastList, setToastList } = useContext(ToastContext)

  return (toastOptions: ToastOptions) => {
    const newToast: InternalToastOptions = { ...toastOptions, id: Math.random().toString(36), lifecycle: ToastLifecycle.TRANSITION_IN }
    setToastList([...toastList, newToast])
  }
}

export { Toast, ToastContext, ToastItem }

export type { ToastOptions }
